module.exports = __webpack_public_path__ + "static/6-4c94e0123d5c14663ca3dd9c23143657.jpeg";